import {useMutation} from '@apollo/client/react';
import {Job} from '@cp/model';
import {CREATE_QUESTION_VALIDATION_JOB} from '../sharedQueries';

export function useCreateQuestionValidationJob() {
  const [createQuestionValidationJobMutation, {loading, error}] = useMutation<
    {createQuestionValidationJob: Job},
    {moduleId: string; topics?: string[]; difficulties?: number[]}
  >(CREATE_QUESTION_VALIDATION_JOB);

  /**
   * Create a question validation job
   * @param moduleId - The module ID to validate questions for
   * @param topics - Optional array of topics to validate (if not provided, validates all topics)
   * @param difficulties - Optional array of difficulties to validate (if not provided, validates all difficulties)
   * @returns Job if successful, otherwise undefined
   */
  const createQuestionValidationJob = async (moduleId: string, topics?: string[], difficulties?: number[]) => {
    const result = await createQuestionValidationJobMutation({
      variables: {moduleId, topics, difficulties},
    });

    return result.data?.createQuestionValidationJob;
  };

  return {
    createQuestionValidationJob,
    loading,
    error,
  };
}
